export function getBackgroundColor(state, theme) {
    return ({ selected }) => {
        if (state === 'init') {
            return selected ? theme.colors.grey15 : 'none';
        }
        if (state === 'active') {
            return theme.colors.grey15;
        }
        return '';
    };
}
export function getBorderColor(state, theme) {
    return ({ today, selected, disabled }) => {
        if (state === 'init') {
            let borderColor = today ? theme.colors.warning : 'transparent';
            borderColor = selected ? 'transparent' : borderColor;
            borderColor = disabled ? 'teal' : borderColor;
            return borderColor;
        }
        if (state === 'hover') {
            let background = today ? theme.colors.warning : 'transparent';
            background = selected ? 'transparent' : background;
            background = disabled ? 'teal' : background;
            return background;
        }
        if (state === 'focus') {
            let background = today ? theme.colors.warning : 'transparent';
            background = selected ? 'transparent' : background;
            background = disabled ? 'teal' : background;
            return background;
        }
        if (state === 'active') {
            let background = today ? theme.colors.warning : 'transparent';
            background = selected ? 'transparent' : background;
            background = disabled ? 'teal' : background;
            return background;
        }
        return '';
    };
}
export function getTextColor(state, theme) {
    return ({ today, selected, disabled, isInPast, thisMonth }) => {
        if (state === 'init') {
            let color = isInPast ? theme.colors.grey14 : theme.colors.black;
            color = today ? theme.colors.black : color;
            color = thisMonth ? color : `rgba(${theme.colors.transparentBlack}, 0.36)`;
            color = disabled ? `rgba(${theme.colors.transparentBlack}, 0.36)` : color;
            color = selected ? theme.colors.white : color;
            return color;
        }
        return '';
    };
}
export function getAppointmentColor(state, theme) {
    return ({ selected, disabled, isInPast, thisMonth }) => {
        if (state === 'init') {
            let color = isInPast ? `rgba(${theme.colors.transparentBlack}, 0.5)` : theme.colors.warning;
            color = selected ? theme.colors.white : color;
            color = disabled ? `rgba(${theme.colors.transparentBlack}, 0.26)` : color;
            color = thisMonth ? color : `rgba(${theme.colors.transparentBlack}, 0.26)`;
            return color;
        }
        return '';
    };
}
